/**
 * 
 * @copyright     (c) 2024-2025 Gist Applications Inc.
 * @author        Greg Olive greg@gist-apps.com
 * @package       gift-card-pro
 * 
 * /assets/js/React/Proxy/pages/GiftCardBalance/_sections/BalanceCodeForm.js
 * Created:       Mon May 06 2024
 * Modified By:   Greg Olive
 * Last Modified: Wed Dec 17 2025
 */

import React, { useState } from "react";
import { Button, TextField, LoadingSpinner } from "@proxy/_components";
import AdditionalDetails from './AdditionalDetails';

/**
 *
 * @param { string } code
 *
 * @param { string } email
 *
 * @returns Balance form HTML
 */
export default function BalanceCodeForm({
  code,
  setCode,
  monthUpdatedAt,
  setMonthUpdatedAt,
  initialValue,
  setInitialValue,
  getGiftCard,
  giftCard,
  translations,
  loading
  }) {

  return (
    <div className="gc__grid-item">
      <form className="gc__flex-column" onSubmit={(e) => getGiftCard(e, 'test')}>
        <TextField
          placeholder={translations.purchase.code_entry_placeholder}
          type={"text"}
          value={code}
          aria-label="Gift Card Code"
          onChange={(e) => setCode(e.target.value)}
        />
        {(giftCard && giftCard.code === 1000 &&
          <AdditionalDetails
            translations={translations}
            initialValue={initialValue}
            setInitialValue={setInitialValue}
            monthUpdatedAt={monthUpdatedAt}
            setMonthUpdatedAt={setMonthUpdatedAt}
          />
        )}
        <Button className="gc__balance-button" type={"submit"}>
          { loading ? (<LoadingSpinner></LoadingSpinner>) : translations.purchase.balance_check_button }
        </Button>
      </form>
    </div>
  )
}
